import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'

import Home from '../component/Home'
import About from '../component/About'
import RoomsAndServices from '../component/Rooms'
import Attractions from '../component/Attractions'
import Gallery from '../component/Gallery'
import TeamDetails from '../component/TeamDetails'
import Contact from '../component/Contact'
import App from '../component/App'


const Routing = () => {

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Routes>
                <Route path="/" element={<App />}>
                    <Route path="/" element={<Home />}></Route>
                    <Route path="/about" element={<About />} />
                    <Route path="/rooms" element={<RoomsAndServices />} />
                    <Route path="/attractions" element={<Attractions />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/team-details" element={<TeamDetails />} />
                    <Route path="/contact" element={<Contact />} />
                </Route>
            </Routes>
        </>
    );
}

export default Routing